<form [formGroup]="form" class="app-form">
  <mat-form-field appearance="outline" class="app-block">
    <mat-label i18n>Location</mat-label>

    <input matInput formControlName="search" i18n-placeholder placeholder="Search..." [matAutocomplete]="auto">

    <mat-autocomplete role="combobox" #auto [displayWith]="displayLabel" (optionSelected)="selected($event)"
      autoActiveFirstOption>

      <mat-option *ngIf="isLoading else show">
        <app-loading></app-loading>
      </mat-option>

      <ng-template #show>
        <mat-option *ngFor="let feature of features$  | async " [value]="feature">
          <span>{{feature.place_name}}</span>
        </mat-option>
      </ng-template>

    </mat-autocomplete>
  </mat-form-field>
</form>
